var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCutlery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/icons-food/cutlery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons-food/cutlery",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-cutlery",
    transform: "translate(6.000000, 6.000000)",
    fill: "#0D6EFD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8125,0 C5.25512656,0 3.33862344,1.89209062 2.05078125,4.00390625 C0.762939062,6.11572344 0,8.61816406 0,10.9375 C0,14.9719234 2.78320312,17.9138187 6.25,18.6035156 L6.25,35.9375 L9.375,35.9375 L9.375,18.6035156 C12.8417969,17.9138187 15.625,14.9719234 15.625,10.9375 C15.625,8.61816406 14.8620609,6.11572344 13.5742188,4.00390625 C12.2863766,1.89209062 10.3698734,0 7.8125,0 Z M18.75,0 L18.75,10.9375 C18.75,13.8305672 20.7519531,16.2475594 23.4375,16.9433594 L23.4375,35.9375 L26.5625,35.9375 L26.5625,16.9433594 C29.2480469,16.2475594 31.25,13.8305672 31.25,10.9375 L31.25,0 L28.125,0 L28.125,10.9375 C28.125,12.6831063 26.7456062,14.0625 25,14.0625 C23.2543953,14.0625 21.875,12.6831063 21.875,10.9375 L21.875,0 L18.75,0 Z M23.4375,0 L23.4375,10.9375 C23.4375,11.7980953 24.1394047,12.5 25,12.5 C25.8605953,12.5 26.5625,11.7980953 26.5625,10.9375 L26.5625,0 L23.4375,0 Z M7.8125,3.125 C8.70971719,3.125 9.91210938,4.01000937 10.8886719,5.61523438 C11.8652344,7.22045937 12.5,9.36889687 12.5,10.9375 C12.5,14.0686031 10.546875,15.625 7.8125,15.625 C5.078125,15.625 3.125,14.0686031 3.125,10.9375 C3.125,9.36889687 3.75976562,7.22045937 4.73632812,5.61523438 C5.71289062,4.01000937 6.91528281,3.125 7.8125,3.125 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.c1b6280ba99ea31ca67eea7620b58476.svg";
export { ForwardRef as ReactComponent };